import React, { useState } from 'react';

function SurveyStepTwentyFive({ formData, onNext }) {
    const [mentalHealthSupport, setMentalHealthSupport] = useState(formData.mentalHealthSupport || '');
    const [mentalHealthComments, setMentalHealthComments] = useState(formData.mentalHealthComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!mentalHealthSupport) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ mentalHealthSupport, mentalHealthComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 6: Employee Well-being</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How well do you feel the company supports your mental health needs? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`mental-health-support-${option}`}
                            name="mentalHealthSupport"
                            value={option}
                            checked={mentalHealthSupport === option}
                            onChange={() => setMentalHealthSupport(option)}
                        />
                        <label htmlFor={`mental-health-support-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={mentalHealthComments}
                    onChange={(e) => setMentalHealthComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!mentalHealthSupport}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepTwentyFive;
